import type { NDateLocale } from './enUS'
import { mk } from 'date-fns/locale'

const dateMkMK: NDateLocale = {
  name: 'mk-MK',
  locale: mk
}

export default dateMkMK
